import script from "./duty-result-appeal.vue?vue&type=script&lang=ts&setup=true"
export * from "./duty-result-appeal.vue?vue&type=script&lang=ts&setup=true"

import "./duty-result-appeal.vue?vue&type=style&index=0&id=bb5e1354&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb5e1354"]])

export default __exports__